import React, { PureComponent } from "react";
import "./NavButtons.scss";
import { SECTION_MAPPING } from "../../constants";

interface Props {
  setSection: Function;
}

class NavButtons extends PureComponent<Props> {
  render() {
    const { setSection } = this.props;

    return (
      <div className="NavButtons">
        {SECTION_MAPPING.slice(1).map(d => (
          <button
            key={d.title}
            className={"button " + d.color}
            onClick={() => setSection(d)}
          >
            <img src={process.env.PUBLIC_URL + d.path} />
            <span>{d.title}</span>
          </button>
        ))}
      </div>
    );
  }
}

export default NavButtons;
